import React, {  useState } from 'react'
import PropTypes from 'prop-types'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'

import * as delimitReportActions from 'action/demarcateReport'
import * as reportActions from 'action/report'

import CommonReport from 'component/newCommonReport/newCommonReport'
import columns from 'component/report/demarcateReportNew/columns'
import StatusType from 'constants/StatusType'
import { formatColumnsByType } from 'utils/formatColumnsByType'

const STOCK_TRANSFER_CSV = 20

const DemarcateReportNew = ({
  auth: { user },
  translate,
  fetch,
  fetchAsyncReports,
}) => {
  const [formData, setFormData] = useState({})
  const [tableColumns] = useState(columns)

  const statusOptions = StatusType.allStatus().map((i) => ({
    ...i,
    label: translate(i.label),
  }))

  const fields = [
    {
      type: 'branchs',
      name: 'branchIdList',
      label: translate('irc.store'),
      help_text: translate('irc.choose-store'),
      error_text: translate('field_must_be_filled'),
      required: true,
      onChangeValue: (e) => {
        setFormData({
          ...formData,
          listRegionsAndBranchs: e.target.value,
        })
      },
    },
    {
      type: 'sections',
      name: 'sectionIdList',
      label: translate('irc.section'),
      help_text: translate('irc.choose-section'),
      error_text: translate('field_must_be_filled'),
      required: false,
      onChangeValue: (e) => {
        setFormData({
          ...formData,
          sectionInputContent: e,
        })
      },
      attrs: {
        disabled: Boolean(formData.cdLm) && formData.cdLm.length > 0,
      },
    },
    {
      type: 'input',
      name: 'cdLm',
      label: translate('lm_label'),
      help_text: translate('mobile.hint.lm'),
      error_text: translate('field_must_be_filled'),
      required: false,
      onChangeValue: (e) => {
        setFormData({
          ...formData,
          cdLm: e.target.value,
        })
      },
      attrs: {
        disabled:
          Boolean(formData.sectionInputContent) &&
          formData.sectionInputContent.length > 0,
        minLength: 8,
        maxLength: 8,
        mask: '99999999',
      },
    },
    {
      type: 'select',
      name: 'statusType',
      required: false,
      label: translate('status'),
      help_text: translate('transferenceRequestFilterFragment.selectStatus'),
      attrs: {},
      options: statusOptions,
    },
    {
      type: 'date_range',
      name: 'dtRange',
      label: translate('field.period.hint'),
      help_text: translate('kardex.field.dtRef.placeholder'),
      error_text: translate('field_must_be_filled'),
      required: true,
    },
  ]

  function onExport(callback) {
    fetchAsyncReports(user.dsToken, { tpReport: STOCK_TRANSFER_CSV }, formData)
    callback()
  }

  async function onSubmit(submitData, setResponseInTable) {
    const formattedValues = {
      ...submitData,
      dtEnd: submitData.dtRange ? submitData.dtRange[1] : '',
      dtStart: submitData.dtRange ? submitData.dtRange[0] : '',
      hasPagination: true,
      size: submitData.limit,
    }
    delete formattedValues.dtRange
    setFormData(formattedValues)
    await fetch(user.dsToken, formattedValues, (response, count) => {
      const valuesFormattedByTypes = formatColumnsByType(
        columns,
        response,
        translate
      )
      setResponseInTable({ total: count, data: valuesFormattedByTypes })
    })
  }
  return (

    <CommonReport
      title={translate('delimit.report.title')}
      onExport={onExport}
      onSubmit={onSubmit}
      columns={tableColumns}
      fields={fields}
      user={user}
      limit={10}
      translate={translate}
      emptyReportMsg='no.data.found'
      order
      defaultOrder={'creatTs'}
    />


  )
}
DemarcateReportNew.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  current: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  demarcateReportList: PropTypes.array.isRequired,
  fetch: PropTypes.func.isRequired,
  fetchAsyncReports: PropTypes.func.isRequired,
}

/* istanbul ignore next */
const mapStateToProps = ({ delimitReportReducer, paginateReducer }) => ({
  demarcateReportList: delimitReportReducer.list,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...delimitReportActions,
      ...reportActions,
    },
    dispatch
  )
}

const DemarcateReportNewTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(DemarcateReportNew)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DemarcateReportNewTranslated)

export { DemarcateReportNew }
